import React, { useMemo } from 'react';
import { Row } from "tea-component";
import { getLocale, shallowEqual, useIntl, useSelector } from 'umi';
import CountryRegionRowItem from '@/pages/dashboard/components/CountryRegionRowItem';
import useData from './useData';

import SvgIcon from '@/pages/home/components/SvgIcon';
import { CountriesContextsProps } from '../_type';
import './index.scss'

// todo ts 补齐
const CountriesContexts = (props: CountriesContextsProps) => {
	const { filterVal, filterLoading, regionDataType = 'os', metric } = props;

	const { formatMessage } = useIntl() // 中英切换方法 
	const locale = getLocale();
	const gameCode = useSelector((state: any) => {
		return state?.dashboard?.currentGame?.game_code
	}, shallowEqual);

	const compData = useData(
		filterVal,
		filterLoading,
		"daily",
		regionDataType,
		metric
	)

	const { data, loading, error, isSingle } = compData || {};

	const AU_MAP: any = {
		dau: 'DAU',
		new: 'New',
	}

	const metrics = AU_MAP?.[metric];

	const titleContent = useMemo(() => {
		const titleMap: any = {
			dau: {
				os: formatMessage({ id: 'overview_monthly_breakdown_dau_platform' }),
				country: formatMessage({ id: 'overview_monthly_breakdown_dau_country' }),
				region: formatMessage({ id: 'overview_monthly_breakdown_dau_region' }),
			},
			new: {
				os: formatMessage({ id: 'overview_monthly_breakdown_new_platform' }),
				country: formatMessage({ id: 'overview_monthly_breakdown_new_country' }),
				region: formatMessage({ id: 'overview_monthly_breakdown_new_region' }),
			},
		}

		return {
			name: titleMap?.[metric][regionDataType] || '',
			content: <div className='dbd-line-title-box'> {/* 先不用跳转 */}
				<div className='dbd-line-title'>{titleMap?.[metric][regionDataType] || ''}</div>
				<span className='dbl-region-title-jump'>
					<SvgIcon className='dbd-line-title-icon' type='arrow-right'></SvgIcon>
				</span>
			</div>,
		}

	}, [regionDataType, metric, locale])

	return (
		<Row gap={24} className="dbd-breakdown-box">
			{
				<CountryRegionRowItem
					prefix={metric === 'dau' ? 'Avg' : 'Sum'}
					// titleName={title}
					titleContent={titleContent}
					comConfig={
						{
							isHaveBar: true,
							isHaveLine: true,
							isHavePie: true,
							isHaveMap: regionDataType === 'country',
							isHaveEyes: true,
							isHaveShare:true
						}
					}
					initActiveIndex={regionDataType === 'country' ? 3 : 0}
					titleAndType={metrics}
					regionDataType={regionDataType}
					timeRange={filterVal?.filterValue?.rangeTime}
					loading={loading}
					isSingle={isSingle}
					isError={error}
					data={data}
					isUserQuota={true}
					timeType={filterVal?.timeType}
					gameCode={gameCode}
					morePie
					isAllUpper={true}
				/>
			}
		</Row>
	)
}

export default CountriesContexts